import { InjectionKey, ref, computed, inject, reactive } from 'vue'
import { useStorage } from '@vueuse/core'
import { User } from '/@src/models/user'
import { useI18n } from 'vue-i18n'
import Cookies from 'js-cookie'
import storage from '/@src/utils/storage'
import { getQueryString } from '/@src/utils'

export const userSessionSymbol: InjectionKey<UserSessionData> = Symbol()

export interface UserSessionData {
  token: string
  user: User
  isLoggedIn: boolean
  roles: string[]
  isInternalAdmin: boolean
  adminIds: Array<{ userid: number }>
}

export function checkIsInternalAdmin(session: UserSessionData): boolean {
  if (!session.isLoggedIn || !session.user) return false
  // KV 未配置 admin 列表时，默认放行
  if (!session.adminIds || session.adminIds.length === 0) {
    return true
  }
  
  const userId = Number(session.user.id)
  
  const adminUserIds = session.adminIds.map(item => Number(item.userid))
  
  return adminUserIds.includes(userId)
}

export function initUserSession(): UserSessionData {
  const code = getQueryString('code') || useStorage('token', '')
  if (getQueryString('code')) {
    Cookies.set('X-Hufu-Token', code)
    storage.set('token', code as string)
  }
  const token = ref(code)
  const user = ref<User>(null)
  const isLoggedIn = computed(() => token.value !== '')
  const roles = ref([])
  const isInternalAdmin = ref(false)
  const adminIds = ref<number[]>([])

  return reactive({
    token,
    user,
    isLoggedIn,
    roles,
    isInternalAdmin,
    adminIds,
  })
}

export function getUserRole() {
  const { t } = useI18n()
  const result = ref(t('role-normal-user'))
  if (useUserSession().isLoggedIn) {
    switch (useUserSession().roles[0]) {
      case 'admin':
        result.value = t('role-admin')
        break
      default:
        break
    }
  }
  return result
}

export default function useUserSession() {
  const userSession = inject(userSessionSymbol)
  if (!userSession) {
    throw new Error('UserSession not properly injected in app')
  }
  return userSession
}
